var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
//诉讼待分配
var OutsourceLawsuitStayService = /** @class */ (function () {
    function OutsourceLawsuitStayService() {
    }
    /**
     * 委外管理-诉讼待分配-列表
     */
    OutsourceLawsuitStayService.prototype.searchPendingList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourceLawsuitManageController.searchPendingList,
            data: {
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                departmentType: data.departmentType,
                overdueAmountStart: data.outAmount ? data.outAmount.min : '',
                overdueAmountEnd: data.outAmount ? data.outAmount.max : '',
                overduePeriod: data.overduePeriod,
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                turnSource: data.turnSource,
                productCategory: data.productCategory,
                createTimeStart: FilterService.dateRanageFormat(data.creatTime).start,
                createTimeEnd: FilterService.dateRanageFormat(data.creatTime).end,
                lawNumber: data.lawNumber,
                labelName: data.labelName,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 委外管理-诉讼待分配-分案确认
     */
    OutsourceLawsuitStayService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitManageController.confirmDistributeCase,
            data: data,
        });
    };
    /**
     * 委外管理-诉讼待分配-待分配手动分案预览
     */
    OutsourceLawsuitStayService.prototype.searchSplitPreview = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitManageController.searchSplitPreview,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceLawsuitStayService.prototype, "netService", void 0);
    return OutsourceLawsuitStayService;
}());
export { OutsourceLawsuitStayService };
